export enum ContentTypes {
    LISTE_EVENTI = "Liste Eventi",
    NEWSLETTER = "newsletter",
    ECOMMERCE = "Ecommerce",
    RICHIEDI_APPUNTAMENTO = "Richiedi Appuntamento",
    GENERICO = "Generico"
}